import React from 'react';
import GTMDataLayer from './gtm';

const FilterCategory = (props) => {

  const handleCategoryFilter = (e) => {
    if (e.target.value) {
      props.setFilters({...props.filters, category: e.target.value, page: 0});

      // Get name of the selected category for GTM.
      const selectedCategory = props.category.find(item => item.id == e.target.value);

      // Track blog category changes.
      GTMDataLayer({
        event: 'blog_filter_category',
        pageUrl: location.href,
        filter_category: selectedCategory ? selectedCategory.name : 'All'
      });
    }
  };

  return (
    <div className='filter-category'>
      <h3>{Drupal.t('Category')}</h3>
      <div>
        <select onChange={handleCategoryFilter} defaultValue={props.selected}>
          <option value='all'>{Drupal.t('All')}</option>
          {props.category.map((item, i) => (
            <option key={i} value={item.id}>{item.name}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterCategory;